module.exports = __webpack_public_path__ + "static/aircards-logo-a4f325647d86684685a07cfd1e706f88.png";